import { QueryObject } from '../helpers/helpers';

/* eslint-disable func-names */
/* eslint-disable no-undef */
const heroTabs = () => {
  (function ($) {
    const $tabs = $('.js-hero-tab');
    const $sections = $('.js-page-section');
    const tabActiveClass = 'c-hero-tabs--active';
    const sectionActiveClass = 'o-tab-content--active';

    // this is a hack needed only for the 'get in touch' page
    const isGetInTouchPage = () => $('.js-get-in-touch-locations-tab').length;
    // A list of all css classes of the tab content on the page
    const sectionClasses = ['c-form', 'c-choose-location'];

    const queryObject = new QueryObject();

    /**
     * Show and hide tab content based the 'data-id' value
     * @param {string} id this id value
     */
    const selectTab = (id) => {
      // decoding is necessary for non-latin characters
      const decodedId = window.decodeURIComponent(id);
      let $tabTarget = $tabs.closest(`[data-id=${decodedId}]`);

      // if the selected tab does not exist select the first tab
      if (!$tabTarget.length) {
        $tabTarget = $tabs.first();
      }

      $tabs.removeClass(tabActiveClass);
      $tabTarget.addClass(tabActiveClass);

      if ($sections.length) {
        const $sectionTarget = $sections.closest(`[data-id=${$tabTarget.attr('data-id')}]`);
        $sections.removeClass(sectionActiveClass);
        $sectionTarget.addClass(sectionActiveClass);
      }
    };

    /**
     * Show and hide tab content base on the CSS selector in the 'data-selector' attribute
     * @param {string} selector css selector string
     */
    const selectTabBySelector = (selector) => {
      let $tabTarget = $tabs.closest(`[data-selector=${selector}]`);

      // if the selected tab does not exist select the first tab
      if (!$tabTarget || !$tabTarget.length) {
        $tabTarget = $tabs.first();
      }

      if (!$tabTarget || !$tabTarget.length) {
        return;
      }

      $tabs.removeClass(tabActiveClass);
      $tabTarget.addClass(tabActiveClass);

      const $sectionTarget = $($tabTarget.attr('data-selector'));
      sectionClasses.forEach((item) => {
        $(`.${item}`).hide();
      });
      $sectionTarget.show();
    };

    // choose the tab to open on page load
    if (queryObject.params.tab) {
      if (isGetInTouchPage()) {
        // HACK: for the 'get in touch' page
        selectTabBySelector($tabs.closest(`[data-id=${queryObject.params.tab}]`).attr('data-selector'));
      } else {
        selectTab(queryObject.params.tab);
      }
    } else if (isGetInTouchPage()) {
      // HACK: for the 'get in touch' page
      const firstTab = $tabs.first().attr('data-selector');
      if (firstTab && firstTab.length) {
        selectTabBySelector(firstTab);
      }
    } else {
      const firstTab = $tabs.first().attr('data-id');
      selectTab(firstTab);
    }

    $tabs.on('click', (e) => {
      const $target = $(e.currentTarget);
      // HACK: for the 'get in touch' page
      queryObject.set({ tab: $target.attr('data-id') }, (a) => {
        if (isGetInTouchPage()) {
          selectTabBySelector($target.attr('data-selector'));
          return;
        }
        selectTab(a.tab);
      });
    });

    // Another fix for the get in touch page loaction tab bug
    $('.js-hero-tab-fix').on('click', (e) => {
      console.log('hero tab fix');
      if ($('html').attr('lang') === 'zh-hans') {
        window.location.href = '/locations?location=asia';
      } else {
        window.location.href = '/locations?location=europe';
      }
    });

    // Sets the correct tab when the forward/back browser buttons are clicked
    $(window).on('popstate', () => {
      queryObject.get((a) => {
        if (a.tab) {
          selectTab(a.tab);
        }
      });
    });
  }(jQuery));
};

export default heroTabs;
